import { render, staticRenderFns } from "./TopicIntroduction.vue?vue&type=template&id=5b47574e&scoped=true"
import script from "./TopicIntroduction.vue?vue&type=script&lang=js"
export * from "./TopicIntroduction.vue?vue&type=script&lang=js"
import style0 from "./TopicIntroduction.vue?vue&type=style&index=0&id=5b47574e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47574e",
  null
  
)

export default component.exports